import type { ReactNode } from 'react';

interface Props {
    value: string | ReactNode;
    removeFilter: () => void;
    openFilters: () => void;
}

export const SelectedFilterItem = ({ openFilters, removeFilter, value }: Props) => (
    <li className="selected-filters__item" data-testid="selectedFilterItem">
        <button type="button" className="button button-tag-touch-left" onClick={openFilters} data-testid="open-button">
            <span className="button__text u-screen-reader-only">Åpne filter</span>
            <span>{value}</span>
        </button>
        <button type="button" className="button button-tag-touch-right" onClick={removeFilter} data-testid="remove-button">
            <span className="button__text u-screen-reader-only">Fjern filter {value}</span>
            <i className="icon icon--small icon--cross-white u-ml4" />
        </button>
    </li>
);
